import { addPopupAction } from 'js/components/common/PopupManager';
import { LuckyPopup } from '../IFeelLuckyPopup';

export const showLuckyPopupAction = ({ onClose, onLogin, title, description } = {}, uniqueGame) => addPopupAction({
    id: 'iFeelLuckyPopup',
    component: LuckyPopup,
    layer: 'IFEELLUCKY',
    onLogin,
    onClose,
    title,
    description,
    uniqueGame
});
